import React, { useState, useEffect, useMemo } from "react";
import { Modal, Input, Row, Col, Button, Collapse, message } from "antd";
import { CloseOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";
import DeleteIcon from "../../assets/images/delete1.svg";
import { v4 as uuidv4 } from "uuid";
import BarCodeGroupedHandler from "../BarcodeGroupedHandler";
import { Scrollbars } from "react-custom-scrollbars";
import { numberToWords } from "../../utility/numberToWords";
// import { pricingRuleController } from "./PricingRules/pricingRuleController";
import { pricingRuleController } from "../../../src/components/PointOfSale/Core/PricingRules/pricingRuleController";
import db from "../../database";
import moment from "moment";

const GroupedProducts = (props) => {
  const {
    showCustomMix,
    setShowCustomMix,
    cart,
    setCart,
    customMixItems,
    setCustomMixItems,
    groupName,
    setGroupName,
    groupQty,
    setGroupQty,
    existingGroupItems,
    setExistingGroupItems,
    selectedCustomMix,
    setSelectedCustomMix,
    orderType,
    setOrderType,
    posSaleTypes,
    setPosSaleTypes,
    currenciesData,
    setCurrenciesData,
  } = props;
  const itemsPerPage = 10;
  const [productData, setProductData] = useState([]);
  // const [customMixItems, setCustomMixItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showProductSelection, setShowProductSelection] = React.useState(false);
  // const [groupName, setGroupName] = useState("Custom Mix");
  // const [groupQty, setGroupQty] = useState(1);
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  let taxIncludeFlag = tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

  useEffect(async () => {
    const productsList = await db.products.toArray();

    setProductData(productsList);
  }, []);

  // Filter and sort products
  useEffect(() => {
    let filtered = productData.filter((item) => {
      const lowerQuery = searchQuery.toLowerCase();
      const isValidSegment = item.productSegment !== "CB";
      const matchesSearch =
        item.name.toLowerCase().includes(lowerQuery) || item.value.toLowerCase().includes(lowerQuery) || (item.upc && item.upc.toLowerCase().includes(lowerQuery));
      return isValidSegment && matchesSearch;
    });

    filtered.sort((a, b) => {
      const aInCart = customMixItems.find((item) => item.mProductId === a.mProductId);
      const bInCart = customMixItems.find((item) => item.mProductId === b.mProductId);
      const aQty = aInCart ? aInCart.weight : 0;
      const bQty = bInCart ? bInCart.weight : 0;
      return (bQty > 1) - (aQty > 1);
    });

    setFilteredProducts(filtered);
  }, [searchQuery, productData, customMixItems]);

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  const paginatedData = useMemo(() => {
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredProducts.slice(startIndex, endIndex);
  }, [filteredProducts, currentPage]);

  // Handle page navigation
  const handlePreviousPage = () => {
    setCurrentPage((prev) => Math.max(0, prev - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(totalPages - 1, prev + 1));
  };

  const handleIncrease = (product) => {
    const isInCart = customMixItems.find((item) => item.mProductId === product.mProductId);
    if (isInCart) {
      setCustomMixItems(customMixItems.map((item) => (item.mProductId === product.mProductId ? { ...item, weight: Number(item.weight) + 1 } : item)));
    } else {
      setCustomMixItems([...customMixItems, { ...product, weight: 1, lineId: uuidv4().replace(/-/g, "").toUpperCase() }]);
    }
  };

  const handleDecrease = (product) => {
    const isInCart = customMixItems.find((item) => item.mProductId === product.mProductId);
    if (isInCart && isInCart.weight > 1) {
      setCustomMixItems(customMixItems.map((item) => (item.mProductId === product.mProductId ? { ...item, weight: Number(item.weight) - 1 } : item)));
    } else if (isInCart && isInCart.weight <= 1) {
      setCustomMixItems(customMixItems.filter((item) => item.mProductId !== product.mProductId));
    }
  };

  const handleQuantityChange = (product, value) => {
    const isDecimal = product?.uomData?.[0]?.decimal === "Y";

    // Block input if "." is entered and decimal is not allowed
    if (!isDecimal && value.includes(".")) return;

    const numValue = value === "" ? 0 : Number(value);
    const isInCart = customMixItems.find((item) => item.mProductId === product.mProductId);

    if (numValue <= 0 && isInCart) {
      setCustomMixItems(customMixItems.filter((item) => item.mProductId !== product.mProductId));
    } else if (numValue > 0 && isInCart) {
      setCustomMixItems(customMixItems.map((item) => (item.mProductId === product.mProductId ? { ...item, weight: numValue } : item)));
    } else if (numValue > 0 && !isInCart) {
      setCustomMixItems([
        ...customMixItems,
        {
          ...product,
          weight: numValue,
          lineId: uuidv4().replace(/-/g, "").toUpperCase(),
        },
      ]);
    }
  };

  const handleDelete = (itemToDelete) => {
    setCustomMixItems(customMixItems.filter((item) => item.mProductId !== itemToDelete.mProductId));
  };

  useEffect(() => {
    const totalRecords = 12;
    let filledCurrencies = currenciesData;
    while (filledCurrencies.length < totalRecords) {
      filledCurrencies.push({ id: `placeholder-${filledCurrencies.length}`, value: 999999 });
    }
    setCurrenciesData(filledCurrencies?.sort((a, b) => b.value - a.value));
    db.posSaletypes.toArray().then((saleType) => {
      setPosSaleTypes([...saleType]);
      const saleIndex = saleType.findIndex((st) => st.cwrSaletype.isdefault === "Y");
      setOrderType(saleType[saleIndex]);
    });
  }, []);

  const handleSubmit = async () => {
    if (customMixItems.length > 0) {
      if (!groupName) {
        message.warning("Group name is required. Please enter a name to continue.");
        return;
      }
      const cartObj = (localStorage.getItem("cartObj") && JSON.parse(localStorage.getItem("cartObj"))) || { items: [], total: 0, tax: 0, subTotal: 0 };
      const itemSummery = {
        decimalItems: { totalQty: 0, totalAmount: 0 },
        nonDecimalItems: { totalQty: 0, totalAmount: 0 },
        itemsQty: 0,
        items: 0,
      };
      const prevSummary = cartObj.itemsSummery;
      const totalTaxAmount = customMixItems.reduce((sum, item) => {
        const taxAmount =
          taxIncludeFlag === "Y"
            ? (item.sunitprice - item.sunitprice / (1 + item.taxRate / 100)) * (groupQty || 1) * item.weight
            : item.sunitprice * (item.taxRate / 100) * (groupQty || 1) * item.weight;
        return sum + taxAmount;
      }, 0);

      const totalRealPrice = customMixItems.reduce((sum, item) => {
        return sum + (item.sunitprice || 0);
      }, 0);

      const totalAmount = customMixItems.reduce((sum, item) => {
        return sum + item.sunitprice * (groupQty || 1);
      }, 0);

      const cartTotal = customMixItems.reduce((sum, item) => {
        const sp = parseFloat(item.sunitprice);
        const mrp = sp * item.weight * groupQty;
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
        const nettotal = parseFloat(taxIncludeFlag === "Y" ? mrp : mrp + tax);
        const nettotalFinal = parseFloat(parseFloat(nettotal).toFixed(precision));
        return sum + (nettotalFinal || 0);
      }, 0);

      const childrenID = uuidv4().replace(/-/g, "").toUpperCase();
      let obj = {
        addNewLine: "N",
        batchedForSale: "N",
        batchedForStock: "N",
        batchedProduct: "N",
        batchno: null,
        bunitName: "",
        csBunitId: null,
        customAttributes: [],
        cwrMenuTimeslot: [],
        cwrPcatalogueId: "75A987950FAC4571985E4FDAADC1366F",
        description: "",
        discount: 0,
        discountName: "",
        foodType: "",
        grosslist: 0,
        grossstd: 0,
        grossunit: 0,
        hsncode: "",
        imageUrl: "",
        imageurl: "",
        isDecimal: false,
        isDecimalQty: false,
        isManualQty: false,
        isPromoApplicable: false,
        isQtyDesimal: 2,
        isReturn: false,
        key: 0,
        lineId: uuidv4().replace(/-/g, "").toUpperCase(),
        childrenId: childrenID,
        linegross: 0,
        linenet: 0,
        linetax: 0,
        listPrice: 0,
        listprice: 0,
        mBatchId: null,
        mPricingruleId: null,
        multiPrice: "N",
        name: groupName,
        name2: "",
        netList: 0,
        netStd: 0,
        nettotal: cartTotal,
        netunit: 0,
        newCustomAttributes: [],
        order: "N",
        originalPrice: totalRealPrice,
        priceList: [],
        primaryOrderLine: null,
        productAddons: [],
        // productBrandId: "E0ADAA7F5B5A48B6A95B85003FDE8700",
        productCategoryName: "",
        productId: uuidv4().replace(/-/g, "").toUpperCase(),
        productManufacturerId: null,
        productionCenter: "",
        realPrice: totalRealPrice,
        returnQty: null,
        salePrice: 0,
        salesRepId: null,
        salesRepName: "",
        selectedAddons: [],
        shelfLife: "",
        shortDescription: "",
        showAddons: "N",
        sunitprice: cartTotal,
        // tax: "F6158713393C444B8668ECB081B24D0B",
        taxAmount: parseFloat(parseFloat(totalTaxAmount).toFixed(precision)),
        taxCategory: "",
        taxFlag: "N",
        taxName: "",
        // taxRate: 18,
        type: "I",
        unitPrice: 0,
        unitTax: 0,
        // uom: "E7E885815A7E4318AF4246D8F0B6E493",
        // uom_name: "Unit",
        upc: "",
        upcPricingRule: null,
        value: "",
        weight: groupQty,
        children: customMixItems.map((item) => {
          const sp = parseFloat(item.sunitprice);
          const mrp = sp * item.weight * (groupQty || 1); // Adjust for groupQty
          const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
          const nettotalFinal = parseFloat(taxIncludeFlag === "Y" ? mrp : mrp + tax);
          const nettotalFixed = parseFloat(nettotalFinal);
          const taxAmountItem = taxIncludeFlag === "Y" ? item.sunitprice - item.sunitprice / (1 + item.taxRate / 100) : item.sunitprice * (item.taxRate / 100);
          const taxAmountFixed = parseFloat(parseFloat(taxAmountItem * (groupQty || 1)).toFixed(precision));
          const unitPrice = isFinite(nettotalFinal / (item.weight * (groupQty || 1)))
            ? taxIncludeFlag === "Y"
              ? nettotalFinal / (item.weight * (groupQty || 1)) / (1 + item.taxRate / 100)
              : item?.sunitprice
            : 0;
          const grossUnit = item.sunitprice / item.weight;
          const lineTax = item.slistprice * (1 + item.taxRate / 100);
          const stdTax = item.sunitprice * (1 + item.taxRate / 100);
          const gross_list = taxIncludeFlag === "Y" ? item.slistprice : parseFloat(parseFloat(lineTax).toFixed(precision));
          let netStd = parseFloat(item.sunitprice - item.sunitprice / (1 + item.taxRate / 100));
          const netStdItem = taxIncludeFlag === "Y" ? (item.sunitprice > 0 ? parseFloat(parseFloat(item.sunitprice - netStd).toFixed(precision)) : 0) : item.sunitprice ?? 0;
          const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : stdTax;
          const netList =
            taxIncludeFlag === "Y" ? item.slistprice - parseFloat(parseFloat(item.slistprice - item.slistprice / (1 + item.taxRate / 100)).toFixed(precision)) : item.slistprice;
          return {
            ...item,
            productId: item.mProductId,
            lineId: uuidv4().replace(/-/g, "").toUpperCase(),
            childrenId: childrenID,
            groupedItems: true,
            discount: 0,
            tax: item.cTaxId,
            nettotal: parseFloat(parseFloat(nettotalFinal).toFixed(precision)),
            realPrice: item.sunitprice || 0,
            weight: item.weight * (groupQty || 1),
            isQtyDesimal: item?.uomData?.[0]?.stdprecision ?? 2,
            isDecimalQty: item?.uomData?.[0]?.decimal === "Y" ? true : false,
            // taxAmount: taxAmountFixed,
            taxAmount: parseFloat(parseFloat(tax).toFixed(precision)),
            linetax: nettotalFixed ? taxAmountFixed : 0,
            linenet: nettotalFixed ? parseFloat(parseFloat(nettotalFixed - taxAmountItem * (groupQty || 1)).toFixed(precision)) : 0,
            linegross: parseFloat(parseFloat(nettotalFixed).toFixed(precision)) || 0,
            linestd: nettotalFixed ? parseFloat(parseFloat(grossStd * item.weight).toFixed(precision)) : 0,
            netunit: nettotalFixed ? parseFloat(parseFloat(unitPrice).toFixed(precision)) : 0,
            listPrice: nettotalFixed ? item.slistprice : 0,
            grossunit: nettotalFixed ? parseFloat(parseFloat(unitPrice).toFixed(precision)) * (item.isReturn ? -1 : 1) : 0,
            grosslist: nettotalFixed ? gross_list : 0,
            grossstd: nettotalFixed ? parseFloat(parseFloat(grossStd).toFixed(precision)) : 0,
            netStd: netStdItem,
            netList: nettotalFixed ? parseFloat(parseFloat(netList).toFixed(precision)) : 0,
            actualWeight: item.weight * (groupQty || 1),
            baseQty: item.weight,
          };
        }),
      };

      let updatedItems = [...cartObj.items];

      if (existingGroupItems) {
        const existingGroupIndex = updatedItems.findIndex((item) => item.lineId === selectedCustomMix.lineId);
        if (existingGroupIndex !== -1) {
          updatedItems[existingGroupIndex] = obj;
        } else {
          updatedItems.push(obj);
        }
      } else {
        // Add new group to cart
        updatedItems.push(obj);
      }

      if (cart.couponInput?.length > 0) {
        cart.couponInput = cart.couponInput?.filter((coupon) => {
          if (obj.couponInput !== coupon) {
            return coupon;
          }
        });
      }
      // Flatten all children from updatedItems
      const allChildren = (updatedItems || []).flatMap((item) => (Array.isArray(item.children) ? item.children : []));

      // Then group those children by tax rate
      const groupedItems = allChildren.reduce((acc, item) => {
        const key = item.tax?.rate ?? item.taxRate ?? "0";
        acc[key] = acc[key] || [];
        acc[key].push(item);
        return acc;
      }, {});

      // Calculate tax totals with SGST and CGST
      const groupedItemsByTaxRate = Object.entries(groupedItems).map(([taxRate, items]) => {
        const totalTaxAmount = items.reduce((sum, item) => {
          const taxValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.taxAmount : item.taxAmount) || 0;
          return sum + parseFloat(parseFloat(taxValue).toFixed(precision));
        }, 0);

        const totalNetTotal = items.reduce((sum, item) => {
          const netValue = (item.tax?.rate !== undefined && item.tax?.rate !== null ? item.nettotal : item.nettotal) || 0;
          return sum + parseFloat(parseFloat(netValue).toFixed(precision));
        }, 0);

        // Calculate SGST and CGST (assuming they're either explicitly provided or half of total tax)
        const totalSgstAmount = items.reduce((sum, item) => {
          const sgstValue = item.sgst || item.tax?.sgst || parseFloat(item.taxAmount || 0) / 2;
          return sum + parseFloat(parseFloat(sgstValue).toFixed(precision));
        }, 0);

        const totalCgstAmount = items.reduce((sum, item) => {
          const cgstValue = item.cgst || item.tax?.cgst || parseFloat(item.taxAmount || 0) / 2;
          return sum + parseFloat(parseFloat(cgstValue).toFixed(precision));
        }, 0);

        return {
          taxRate,
          totalLinenet: parseFloat(parseFloat(totalNetTotal - totalTaxAmount).toFixed(precision)),
          totalLinetax: parseFloat(parseFloat(totalTaxAmount).toFixed(precision)),
          totalLinegross: parseFloat(parseFloat(totalNetTotal).toFixed(precision)),
          totalSgst: parseFloat(parseFloat(totalSgstAmount).toFixed(precision)),
          totalCgst: parseFloat(parseFloat(totalCgstAmount).toFixed(precision)),
        };
      });

      customMixItems.forEach((item) => {
        if (Array.isArray(item.children) && item.children.length > 0) {
          item.children.forEach((child) => {
            const isDecimal = child.uomData?.[0]?.decimal === "Y" || child.isDecimal;
            const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";
            const itemWeight = child.weight * (groupQty || 1);
            const netTotal = parseFloat(parseFloat(child.sunitprice * itemWeight).toFixed(precision));

            itemSummery.itemsQty += itemWeight;
            itemSummery.items += 1;
            itemSummery[summaryKey].totalQty += itemWeight;
            itemSummery[summaryKey].totalAmount += netTotal;
          });
        } else {
          const isDecimal = item.uomData?.[0]?.decimal === "Y" || item.isDecimal;
          const summaryKey = isDecimal ? "decimalItems" : "nonDecimalItems";
          const itemWeight = item.weight * (groupQty || 1);
          const netTotal = parseFloat(parseFloat(item.sunitprice * itemWeight).toFixed(precision));

          itemSummery.itemsQty += itemWeight;
          itemSummery.items += 1;
          itemSummery[summaryKey].totalQty += itemWeight;
          itemSummery[summaryKey].totalAmount += netTotal;
        }
      });

      const mergedItemSummery = {
        decimalItems: {
          totalQty: (prevSummary.decimalItems?.totalQty || 0) + itemSummery.decimalItems.totalQty,
          totalAmount: (prevSummary.decimalItems?.totalAmount || 0) + itemSummery.decimalItems.totalAmount,
        },
        nonDecimalItems: {
          totalQty: (prevSummary.nonDecimalItems?.totalQty || 0) + itemSummery.nonDecimalItems.totalQty,
          totalAmount: (prevSummary.nonDecimalItems?.totalAmount || 0) + itemSummery.nonDecimalItems.totalAmount,
        },
        itemsQty: (prevSummary?.itemsQty || 0) + itemSummery.itemsQty,
        items: (prevSummary?.items || 0) + itemSummery.items,
      };

      const totalSTD = cartObj.items.reduce((total, item) => {
        const calculateLineSTD = (data) => {
          const sp = parseFloat(data.sunitprice);
          const mrp = sp * data.weight * (groupQty || 1);
          const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + data.taxRate / 100) : (mrp * data.taxRate) / 100;
          const nettotalFinal = parseFloat(taxIncludeFlag === "Y" ? mrp : mrp + tax);
          const nettotalFixed = parseFloat(nettotalFinal);
          const stdTax = data.sunitprice * (1 + data.taxRate / 100);
          const grossStd = taxIncludeFlag === "Y" ? data.sunitprice : stdTax;

          const lineSTD = nettotalFixed ? grossStd * data.weight : 0;

          return lineSTD;
        };

        let itemTotalSTD = 0;

        if (Array.isArray(item.children)) {
          itemTotalSTD = item.children.reduce((childTotal, child) => {
            return childTotal + calculateLineSTD(child);
          }, 0);
        } else {
          itemTotalSTD = calculateLineSTD(item);
        }

        return total + itemTotalSTD;
      }, 0);
      const finalCartTotal = updatedItems.reduce((sum, item) => sum + (item.nettotal || 0), 0);
      const finalCartTax = updatedItems.reduce((sum, item) => sum + (parseFloat(parseFloat(item.taxAmount).toFixed(precision)) || 0), 0);
      const finalCartSubTotal = finalCartTotal - finalCartTax;
      const totalLineStd = customMixItems.reduce((sum, item) => {
        const stdTax = item.sunitprice * (1 + (item.taxRate || 0) / 100);
        const grossStd = taxIncludeFlag === "Y" ? item.sunitprice : stdTax;
        const lineStdRaw = grossStd * item.weight;
        const lineStd = parseFloat(parseFloat(lineStdRaw).toFixed(precision));
        return sum + lineStd;
      }, 0);
      // Update the final cart object
      let finalCartObj = {
        ...cartObj,
        amountInWords: numberToWords(finalCartTotal),
        items: updatedItems,
        total: finalCartTotal,
        tax: finalCartTax,
        subTotal: finalCartSubTotal,
        groupItemsFlag: true,
        totalStd: parseFloat(parseFloat(totalSTD + totalLineStd).toFixed(precision)),
        groupedItemsByTaxRate: groupedItemsByTaxRate,
        itemsSummery: mergedItemSummery,
        // itemsSummery: {
        //   ...(cartObj.itemsSummery || {}),
        //   ...itemSummery,
        // },
      };
      setCart(finalCartObj);
      let updatedCart;
      if (finalCartObj.items?.length > 0) {
        let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
          ? JSON.parse(localStorage.getItem("orderTimeDetails"))
          : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
        orderTimeDetails = {
          ...orderTimeDetails,
          paymentStartTime: "",
          orderStartTime: orderTimeDetails.orderStartTime !== "" ? orderTimeDetails.orderStartTime : moment(new Date()).format("DD-MM-YYYY HH:mm:ss"), // Update orderStartTime to current time
        };
        localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
        updatedCart = obj.isReturn ? finalCartObj : await pricingRuleController(obj, finalCartObj, cart, setCart);
      }
      // cartRef
      if (updatedCart?.couponInput?.length > 0 && cart?.statusType !== "layAway") {
        await Promise.all(
          updatedCart.couponInput.map(async (coupon) => {
            updatedCart = await pricingRuleController(
              obj,
              updatedCart,
              cart,
              setCart,
              null,
              orderType,
              true,
              coupon.couponCode,
              coupon.referenceId,
              coupon.mPricingCouponId,
              coupon.mPricingruleId
            );
          })
        );
      }
      // localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
      // setCart(finalCartObj);
      localStorage.setItem("cartObj", JSON.stringify(updatedCart));
      setCart(updatedCart);
      setShowCustomMix(false);
      setCustomMixItems([]);
      setGroupName("Custom Mix");
      setGroupQty(1);
      setExistingGroupItems(false);
    }
  };

  return (
    <>
      <Modal
        visible={showCustomMix}
        centered={true}
        width={"68%"}
        closable={true} // Enable closable
        closeIcon={
          <CloseOutlined
            style={{ color: "#2F3856", fontSize: "16px" }}
            onClick={() => {
              setShowCustomMix(false);
              setCustomMixItems([]);
              setGroupName("Custom Mix");
              setShowProductSelection(false);
              setGroupQty(1);
              setSearchQuery("");
              localStorage.removeItem("customMix");
              localStorage.removeItem("productSegment");
              setExistingGroupItems(false);
            }}
          />
        } // Custom close icon
        footer={null}
      >
        <BarCodeGroupedHandler setCustomMixItems={setCustomMixItems} />
        {showProductSelection ? (
          <div style={{ padding: "5vh 0 0 0", height: "85vh", position: "relative" }}>
            <Input
              placeholder="Search Item Code / Description"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(0);
              }}
              style={{
                borderRadius: "7px",
                padding: "0.8vh 0.8vw",
                border: "1px solid #d9d9d9",
                width: "100%",
              }}
            />
            <Row style={{ padding: "2vh 0" }} gutter={[16, 16]}>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => {
                  const cartItem = customMixItems.find((cartItem) => cartItem.mProductId === item.mProductId);
                  const stdPrecision = item?.uomData?.[0]?.stdprecision ?? 0;
                  const uomName = item?.uomData?.[0]?.name ?? "";
                  const quantity = cartItem ? cartItem.weight : 0;
                  return (
                    <Col key={index} span={12} style={{ padding: "0 8px" }}>
                      <Row style={{ padding: "1.5%", width: "100%", border: "1px solid #d9d9d9", height: "10vh" }}>
                        <Col span={12}>
                          <p
                            title={item.name}
                            style={{
                              margin: 0,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100%",
                            }}
                          >
                            {item.name}
                          </p>
                          <p style={{ margin: 0 }}>
                            {item.sunitprice} - {uomName}
                          </p>
                        </Col>
                        <Col span={12} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <Button
                              onClick={() => handleDecrease(item)}
                              style={{
                                backgroundColor: "#2F3856",
                                color: "#fff",
                                width: "2.5vw",
                                height: "4vh",
                              }}
                              icon={<MinusOutlined />}
                            />
                            <Input
                              type="number"
                              min={0}
                              step={stdPrecision > 0 ? 0.1 ** stdPrecision : 0.1}
                              value={quantity}
                              onChange={(e) => {
                                handleQuantityChange(item, e.target.value);
                              }}
                              onKeyDown={(e) => {
                                const decimal = item?.uomData?.[0]?.decimal === "Y";
                                if (!decimal && (e.key === "." || e.key === "Decimal")) {
                                  e.preventDefault();
                                }
                              }}
                              style={{
                                width: "60px",
                                height: "4vh",
                                // textAlign: "center",
                              }}
                              onBlur={(e) => {
                                const newValue = Number(e.target.value) || 0;
                                handleQuantityChange(item, newValue.toFixed(stdPrecision));
                              }}
                            />
                            {/* <Input
                              type="number"
                              min={0}
                              step={stdPrecision > 0 ? 0.1 ** stdPrecision : 0.1}
                              value={quantity}
                              onChange={(e) => {
                                const decimal = item?.uomData?.[0]?.decimal === "Y";
                                const value = e.target.value;
                                handleQuantityChange(item, value);
                              }}
                              onKeyDown={(e) => {
                                const decimal = item?.uomData?.[0]?.decimal === "Y";
                                if (!decimal && (e.key === "." || e.key === "Decimal")) {
                                  e.preventDefault(); // Prevent '.' from being entered
                                }
                              }}
                              onBlur={(e) => {
                                const newValue = Number(e.target.value) || 0;
                                handleQuantityChange(item, newValue.toFixed(stdPrecision));
                              }}
                              style={{
                                width: "60px",
                                height: "4vh",
                              }}
                            /> */}

                            <Button
                              onClick={() => handleIncrease(item)}
                              style={{
                                backgroundColor: "#2F3856",
                                color: "#fff",
                                width: "2.5vw",
                                height: "4vh",
                              }}
                              icon={<PlusOutlined />}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  );
                })
              ) : (
                <p style={{ textAlign: "center", width: "100%" }}>No products found</p>
              )}
            </Row>
            <div style={{ position: "absolute", bottom: "0vh", width: "100%", padding: "1vh 0" }}>
              <Row align="middle" justify="space-between">
                <Col>
                  <Button
                    disabled={currentPage === 0}
                    onClick={handlePreviousPage}
                    style={{
                      textAlign: "center",
                      backgroundColor: currentPage === 0 ? "#ccc" : "#2F3856",
                      width: "4vw",
                      height: "6.5vh",
                      color: "#fff",
                      borderRadius: "5px",
                      marginRight: "1vw",
                    }}
                  >
                    {"<"}
                  </Button>
                  <span style={{ fontWeight: "bold", margin: "0 1vw" }}>
                    Page {currentPage + 1} of {totalPages || 1}
                  </span>
                  <Button
                    disabled={currentPage >= totalPages - 1}
                    onClick={handleNextPage}
                    style={{
                      textAlign: "center",
                      backgroundColor: currentPage >= totalPages - 1 ? "#ccc" : "#2F3856",
                      width: "4vw",
                      height: "6.5vh",
                      color: "#fff",
                      borderRadius: "5px",
                      marginLeft: "1vw",
                    }}
                  >
                    {">"}
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={() => setShowProductSelection(false)}
                    style={{
                      backgroundColor: "#2F3856",
                      color: "#fff",
                      width: "8vw",
                      height: "6.5vh",
                      borderRadius: "5px",
                      marginRight: "1vw",
                    }}
                    disabled={customMixItems.length === 0}
                  >
                    Okay
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <div style={{ height: "81vh", position: "relative" }}>
            <Row justify="space-between" align="middle" style={{ marginBottom: "1vh", marginTop: "3vh" }}>
              <Col>
                <h3>Create Grouped Product</h3>
              </Col>
              <Col>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setShowProductSelection(true)}
                  style={{ backgroundColor: "#2F3856", borderColor: "#2F3856", color: "#fff" }}
                >
                  Add Products
                </Button>
              </Col>
            </Row>
            <Row align="middle" style={{ marginBottom: "3vh", marginTop: "1vh", marginLeft: "5vw", marginRight: "1vw" }}>
              <Col style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <h3 style={{ marginRight: "7px" }}>Group Name</h3>
                <Input
                  value={groupName}
                  onChange={(e) => {
                    setGroupName(e.target.value);
                  }}
                  style={{ width: "300px", borderRadius: "5px" }}
                />
              </Col>
              <Col style={{ display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "2vw" }}>
                <div style={{ display: "flex", alignItems: "cen7er" }}>
                  <span style={{ fontSize: "1.1em", fontWeight: 400, color: "#0F0718", marginRight: "8px" }}>Qty:</span>
                  <Button
                    icon={<MinusOutlined style={{ fontSize: "15px" }} />}
                    style={{
                      width: "30px",
                      height: "28px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingRight: 6,
                      marginRight: "15px",
                      paddingLeft: 6,
                      borderRadius: "5px",
                      paddingTop: 0,
                    }}
                    disabled={(!groupName.trim() && customMixItems.length === 0) || customMixItems.length === 0}
                    onClick={() => setGroupQty((prev) => Math.max(prev - 1, 1))}
                  />
                  <Input value={groupQty} type="text" style={{ width: "70px", textAlign: "center" }} />
                  <Button
                    icon={<PlusOutlined style={{ fontSize: "15px", color: "#fff" }} />}
                    style={{
                      width: "30px",
                      height: "28px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingRight: 6,
                      marginLeft: "15px",
                      paddingLeft: 6,
                      backgroundColor: "#2F3856",
                      borderRadius: "5px",
                    }}
                    disabled={(!groupName.trim() && customMixItems.length === 0) || customMixItems.length === 0}
                    onClick={() => {
                      setGroupQty((prev) => prev + 1);
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row style={{ padding: "0.1rem 0.75rem", fontSize: "0.75rem", fontWeight: 600, color: "#2F3856", borderBottom: "1px solid #e8e8e8", marginBottom: "0.5rem" }}>
              <Col span={6}>Name</Col>
              <Col span={4} style={{ textAlign: "right" }}>
                Unit Price
              </Col>
              <Col span={5} style={{ textAlign: "center" }}>
                Qty
              </Col>
              <Col span={2} style={{ textAlign: "right" }}>
                Total Qty
              </Col>
              <Col span={5} style={{ textAlign: "center" }}>
                Total Price
              </Col>
              <Col span={2}></Col>
            </Row>
            <Scrollbars style={{ height: "54vh" }}>
              {customMixItems.map((item) => {
                const unitPrice = parseFloat(item.sunitprice) || 0;
                const quantity = parseFloat(item.weight * (groupQty || 1)) || 0;
                const totalPrice = unitPrice * quantity;
                return (
                  <Row
                    key={item.id || item.name}
                    style={{
                      padding: "0.5rem 0.9rem",
                      width: "100%",
                      marginBottom: "0.4rem",
                      height: "auto",
                      alignItems: "center",
                    }}
                  >
                    <Col span={6}>
                      <p
                        title={item.name}
                        style={{
                          margin: 0,
                          fontSize: "0.8rem",
                          fontWeight: 500,
                          color: "#333",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                        }}
                      >
                        {item.name}
                      </p>
                    </Col>
                    <Col span={4} style={{ textAlign: "right" }}>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.8rem",
                          color: "#2F3856",
                        }}
                      >
                        {unitPrice.toLocaleString("en-IN")}
                      </p>
                    </Col>
                    <Col span={5} style={{ textAlign: "center" }}>
                      <Input
                        type="number"
                        min={0}
                        value={item.weight}
                        onChange={(e) => handleQuantityChange(item, e.target.value)}
                        style={{
                          width: "60px",
                          height: "25px",
                          textAlign: "center",
                          fontSize: "0.8rem",
                        }}
                        onBlur={(e) => {
                          const newValue = Number(e.target.value) || 0;
                          handleQuantityChange(item, newValue.toString());
                        }}
                      />
                    </Col>
                    <Col span={2} style={{ textAlign: "right" }}>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.8rem",
                          color: "#2F3856",
                        }}
                      >
                        {quantity}
                      </p>
                    </Col>
                    <Col span={5} style={{ textAlign: "center" }}>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "0.8rem",
                          color: "#2F3856",
                        }}
                      >
                        {totalPrice.toLocaleString("en-IN")}
                      </p>
                    </Col>
                    <Col span={2} style={{ textAlign: "center" }}>
                      <img
                        src={DeleteIcon}
                        style={{
                          height: "2.5vh",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDelete(item)}
                      />
                    </Col>
                  </Row>
                );
              })}
            </Scrollbars>
            <Button
              style={{
                position: "absolute",
                bottom: "0.5rem",
                right: "0.5rem",
                backgroundColor: "#2F3856",
                color: "#fff",
                width: "7vw",
                height: "4.5vh",
                borderRadius: "3px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                fontSize: "0.85rem",
              }}
              // disabled={!groupName.trim()}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        )}
      </Modal>
    </>
  );
};

export default GroupedProducts;
